import React, { useContext } from "react";
import { Mobile, Default } from "../../../../utils/deviceHelpers";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import { BuildARingContext } from "../../../../utils/stateHandlers/contexts";

export default function BarDetailTable(props) {
  const { barState } = useContext(BuildARingContext);
  const { priceLoaded, ring } = barState;
  return (
    <>
      <Mobile>
        <Typography variant="h2" sx={{ marginTop: "2rem" }}>
          Details
        </Typography>
        <Table size="small">
          <TableBody>
            {priceLoaded ? (
              <>
                {ring &&
                  ring.ringDetails.map((data) => (
                    <TableRow key={data.label}>
                      {Object.values(data).map((detailData) => (
                        <TableCell key={detailData}>
                          <Typography>{detailData}</Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
              </>
            ) : (
              <>
                <TableRow>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width="10rem"
                      className="float-right"
                    />
                  </TableCell>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width="10rem"
                      className="float-right"
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width="10rem"
                      className="float-right"
                    />
                  </TableCell>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width="10rem"
                      className="float-right"
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width="10rem"
                      className="float-right"
                    />
                  </TableCell>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width="10rem"
                      className="float-right"
                    />
                  </TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </Mobile>
      <Default>
        <Typography variant="h2" sx={{ width: "92.5%", marginTop: "2rem" }}>
          Details
        </Typography>
        <Table size="small" sx={{ width: "92.5%" }}>
          <TableBody>
            {priceLoaded ? (
              <>
                {ring &&
                  ring.ringDetails.map((data) => (
                    <TableRow key={data.label}>
                      {Object.values(data).map((detailData) => (
                        <TableCell key={detailData}>
                          <Typography>{detailData}</Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
              </>
            ) : (
              <>
                <TableRow>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width="10rem"
                      className="float-right"
                    />
                  </TableCell>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width="10rem"
                      className="float-right"
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width="10rem"
                      className="float-right"
                    />
                  </TableCell>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width="10rem"
                      className="float-right"
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width="10rem"
                      className="float-right"
                    />
                  </TableCell>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width="10rem"
                      className="float-right"
                    />
                  </TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </Default>
    </>
  );
}
